import { IReinstateablePolicy } from "config";
import { gql } from "config/graphql";
import { SuccessResponse } from "config/types";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface ICreateReinstatementInvoiceData {
  createReinstatementInvoice: SuccessResponse;
}

export const createReinstatementInvoiceMutation = async (policyId: IReinstateablePolicy["id"]) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation createReinstatementInvoice($input: CreateReinstatementInvoiceInput!) {
      createReinstatementInvoice(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<ICreateReinstatementInvoiceData>({
    mutation,
    variables: {
      input: {
        policyId,
      },
    },
  });
  return { data: assertDefined(data) };
};
